module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ga-Ha-Ic-Jb.ab00fa2c.png";